import React from 'react'
import Simplebutton from '../Buttons/Simplebutton';
import {BsStarFill} from 'react-icons/bs';
import {BsStarHalf} from 'react-icons/bs';
const ProductCard2 = () => {
  return (
    <div className='bg-white border border-gray-300'>
        <div className='w-full flex px-2 py-4 '>
            <div className='basis-4/12 px-1'>
                <img src="/images/biscuite.avif" className='w-full' alt="" />
            </div>
            <div className='basis-6/12 px-2'>
                 <h1 className='text-md font-medium text-rose-600 py-1'>YITH Essential Compare</h1>
                 <p className=' text-sm font-normal text-gray-500'>YITH woocommerce Compare allows you to compare more products of your shop in one complete table . Woocommerce Compatible up to 3.6 </p>
                 <h2 className='text-sm font-bold text-green-700 py-2 '>By YITH</h2>
            </div>
            <div className=''>
                <Simplebutton/>
                <h1 className='text-xs text-blue-500 font-medium py-1'><a href="/">More Details</a></h1>
            </div>
        </div>
        <div className='flex  w-full px-2 py-2 border border-transparent border-t-gray-300'>
            <div className='basis-1/2'>
            <p className='flex text-yellow-400'><BsStarFill/><BsStarFill/><BsStarFill/><BsStarFill/><BsStarHalf/></p>
         <h1 className='text-xs font-medium py-1 '>200,000+ Active installation </h1>
            </div>
            <div className='basis-1/2'>
         <h1 className='text-sm text-right '><span className='text-sm font-semibold'>Lat updated : </span>1 month ago</h1>
         <h1 className='text-xs font-medium text-right py-1'>Complatible with your version of Wordpress</h1>
     </div>
        </div>
    </div>
  )
}

export default ProductCard2